import DEDUPE_FIELDS from './handlers/dedupeFields.js'
import GEO_FIELDS from './handlers/geo.js'
import FIELDS_FIELDS from './handlers/fields.js'
import COMPRESSION_FIELDS from './handlers/compression.js'
import NUM_OF_FILES_FIELDS from './handlers/numOfFiles.js'

export const checkValue = (value) => {
  switch (true) {
    // TODO: Check if it's a number or list of two letter codes (for listed countries)
    case typeof value === 'number':
    case value.split(',').every((code) => code.trim().length === 2):
      return true
    default:
      return false
  }
}

export const FIELDS = {
  ...GEO_FIELDS,
  ...DEDUPE_FIELDS,
  ...FIELDS_FIELDS,
  ...COMPRESSION_FIELDS,
  ...NUM_OF_FILES_FIELDS,
}
